import { gql } from '@apollo/client';

export const GET_DELIVERY_ADDRESS = gql`
  query GetEquipmentDeliveryAddress($id: ID!) {
    equipment: equipmentById(id: $id) {
      id: equipmentId
      deliveryAddress {
        city
        state
        country
        postalCode
        streetAddress
      }
    }
  }
`;
